var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// normalizeName jau eksportuota kaip funkcija aukščiau
// Rasti visas stoteles iš maršruto
export function stationsAlongPath(path, cache, allowedNormToDisplay) {
    const pathSet = new Set(path);
    const cum = new Map();
    cum.set(path[0], 0);
    for (let i = 1; i < path.length; i++) {
        const a = cache.nodes.get(path[i - 1]);
        const b = cache.nodes.get(path[i]);
        const prev = cum.get(path[i - 1]) || 0;
        if (!a || !b) {
            cum.set(path[i], prev);
            continue;
        }
        cum.set(path[i], prev + haversineKm(a.lat, a.lon, b.lat, b.lon));
    }
    const cellKey = (lat, lon) => `${Math.floor(lat * 100)}_${Math.floor(lon * 100)}`;
    const pathGrid = new Map();
    for (const nodeId of path) {
        const n = cache.nodes.get(nodeId);
        if (!n)
            continue;
        const k = cellKey(n.lat, n.lon);
        if (!pathGrid.has(k))
            pathGrid.set(k, []);
        pathGrid.get(k).push(nodeId);
    }
    function nearestPathNode(lat, lon) {
        const baseX = Math.floor(lat * 100);
        const baseY = Math.floor(lon * 100);
        let best = null;
        let bestD = Infinity;
        for (let dx = -1; dx <= 1; dx++) {
            for (let dy = -1; dy <= 1; dy++) {
                const k = `${baseX + dx}_${baseY + dy}`;
                const ids = pathGrid.get(k);
                if (!ids)
                    continue;
                for (const id of ids) {
                    const n = cache.nodes.get(id);
                    if (!n)
                        continue;
                    const d = haversineKm(lat, lon, n.lat, n.lon);
                    if (d < bestD) {
                        bestD = d;
                        best = id;
                    }
                }
            }
        }
        return best !== null ? { id: best, d: bestD } : null;
    }
    const corridorKm = 0.35;
    const candidates = [];
    for (const s of cache.stationPoints) {
        if (allowedNormToDisplay && !allowedNormToDisplay.has(s.norm))
            continue;
        let pos = null;
        if (pathSet.has(s.trackNodeId)) {
            pos = cum.get(s.trackNodeId) || null;
        }
        else {
            const near = nearestPathNode(s.lat, s.lon);
            if (near && near.d <= corridorKm) {
                pos = cum.get(near.id) || null;
            }
        }
        if (pos === null || pos === undefined)
            continue;
        const displayName = allowedNormToDisplay ? allowedNormToDisplay.get(s.norm) : s.name;
        if (displayName) {
            candidates.push({ pos, name: displayName, norm: s.norm });
        }
    }
    candidates.sort((a, b) => a.pos - b.pos);
    const seen = new Set();
    const stops = [];
    for (const c of candidates) {
        if (seen.has(c.norm))
            continue;
        seen.add(c.norm);
        stops.push(c.name);
    }
    return stops;
}
// Haversine formulė atstumui tarp dviejų koordinačių
export function haversineKm(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.pow(Math.sin(dLat / 2), 2) +
        Math.cos(lat1 * Math.PI / 180) *
            Math.cos(lat2 * Math.PI / 180) *
            Math.pow(Math.sin(dLon / 2), 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
// Normalizuoti stotelės pavadinimą
export function normalizeName(name) {
    if (!name)
        return "";
    return name
        .replace(/\*/g, "") // Pašalina žvaigždutes
        .replace(/\s+/g, " ") // Sujungia kelis tarpus į vieną
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .replace(/[^a-z0-9]/g, ""); // Pašalina visus ne-raidžių/skaitmenų simbolius
}
// Alternatyvūs pavadinimai stotelėms
const stationAliases = {
    'vs bugeniai': ['bugeniai'],
    'vsbugeniai': ['bugeniai'],
    'vs joniskis': ['joniskis'],
    'vsjoniskis': ['joniskis'],
    'vs kena': ['kena'],
    'vskena': ['kena'],
    'vs kybartai': ['kybartai'],
    'vskybartai': ['kybartai'],
    'vs marcinkonys': ['marcinkonys'],
    'vsmarcinkonys': ['marcinkonys'],
    'vs maercinkonys': ['marcinkonys'],
    'vsmaercinkonys': ['marcinkonys'],
    'vs mazeikiai': ['mazeikiai'],
    'vsmazeikiai': ['mazeikiai'],
    'vs mockava': ['mockava'],
    'vsmockava': ['mockava'],
    'vs pagegiai': ['pagegiai'],
    'vspagegiai': ['pagegiai'],
    'vs rokiskis': ['rokiskis'],
    'vsrokiskis': ['rokiskis'],
    'vs skuodas': ['skuodas'],
    'vsskuodas': ['skuodas'],
    'vs stasylos': ['stasylos'],
    'vsstasylos': ['stasylos'],
    'vs turmantas': ['turmantas'],
    'vsturmantas': ['turmantas'],
    'duseikiai': ['duseikiai'],
    'kyviskes ii v keliai': ['kyviskes'],
    'kyviskesiivkeliai': ['kyviskes']
};
// Rankinės stotelės, kurios nėra OSM duomenyse
const manualStations = {
    'jiesia': {
        lat: 54.61111,
        lon: 23.51694,
        gauge: ['1435', '1520'],
        name: 'Jiesia'
    },
    'rokai': {
        lat: 54.5856,
        lon: 23.5167,
        gauge: ['1435', '1520'],
        name: 'Rokai'
    },
    'rokiskis': {
        lat: 55.9697,
        lon: 25.5858,
        gauge: ['1520'],
        name: 'Rokiškis'
    },
    'silainiai': {
        lat: 55.2322874,
        lon: 24.0706799,
        gauge: ['1520'],
        name: 'Šilainiai'
    }
};
function getNameFromTags(tags) {
    if (!tags)
        return "";
    return tags["name:lt"] || tags.name || "";
}
function parseGauges(val) {
    if (!val)
        return [];
    return String(val)
        .split(";")
        .map(s => s.trim())
        .filter(Boolean);
}
function isWayUsableForGauge(tags, gaugeSelected) {
    const gauges = parseGauges(tags === null || tags === void 0 ? void 0 : tags.gauge);
    if (!gauges.length) {
        return true; // Jei gauge nepažymėtas OSM, leidžiame abi vėžės
    }
    return gauges.includes(gaugeSelected || '');
}
function isRailwayWay(tags) {
    if (!tags)
        return false;
    const r = String(tags.railway || "");
    if (!r)
        return false;
    const bad = new Set(["abandoned", "construction", "disused", "razed", "platform"]);
    if (bad.has(r))
        return false;
    return true;
}
function electrifiedFlag(tags) {
    const e = (tags && (tags.electrified || tags.electrification)) ? String(tags.electrified || tags.electrification).toLowerCase() : "";
    if (!e)
        return null;
    if (e === "no" || e === "none")
        return "no";
    return "yes";
}
// Rasti stotelės mazgą grafe
export function findStationNode(cache, displayName, allowedNormToDisplay) {
    const norm = normalizeName(displayName);
    // 1. Tiesioginis match'as
    let node = cache.stationByName.get(norm);
    if (node !== undefined)
        return { node, matchedAs: norm };
    // 2. Alias'ai
    const aliases = stationAliases[norm] || [];
    for (const alias of aliases) {
        const aliasNorm = normalizeName(alias);
        node = cache.stationByName.get(aliasNorm);
        if (node !== undefined) {
            return { node, matchedAs: aliasNorm, viaAlias: alias };
        }
    }
    // 3. Fuzzy match
    for (const [osmNorm, nodeId] of cache.stationByName.entries()) {
        if (norm.length >= 5 && osmNorm.startsWith(norm.slice(0, 5))) {
            return { node: nodeId, matchedAs: osmNorm, fuzzy: true };
        }
    }
    return { node: null, matchedAs: null };
}
// MinHeap Dijkstra algoritmui
class MinHeap {
    constructor() {
        this.a = [];
    }
    push(item) {
        this.a.push(item);
        this._up(this.a.length - 1);
    }
    pop() {
        if (!this.a.length)
            return null;
        const top = this.a[0];
        const last = this.a.pop();
        if (this.a.length) {
            this.a[0] = last;
            this._down(0);
        }
        return top;
    }
    _up(i) {
        while (i > 0) {
            const p = (i - 1) >> 1;
            if (this.a[p].d <= this.a[i].d)
                break;
            [this.a[p], this.a[i]] = [this.a[i], this.a[p]];
            i = p;
        }
    }
    _down(i) {
        const n = this.a.length;
        while (true) {
            let m = i;
            const l = i * 2 + 1;
            const r = i * 2 + 2;
            if (l < n && this.a[l].d < this.a[m].d)
                m = l;
            if (r < n && this.a[r].d < this.a[m].d)
                m = r;
            if (m === i)
                break;
            [this.a[m], this.a[i]] = [this.a[i], this.a[m]];
            i = m;
        }
    }
}
// Dijkstra algoritmas
export function dijkstra(adj, start, goal, edgePenalties) {
    // Jei start ir goal yra vienodi, negalime sukurti maršruto
    if (start === goal)
        return null;
    const dist = new Map();
    const prev = new Map();
    const heap = new MinHeap();
    dist.set(start, 0);
    heap.push({ id: start, d: 0 });
    while (true) {
        const cur = heap.pop();
        if (!cur)
            break;
        if (cur.d !== dist.get(cur.id))
            continue;
        if (cur.id === goal)
            break;
        const edges = adj.get(cur.id) || [];
        for (const e of edges) {
            let edgeCost = e.distKm;
            if (edgePenalties) {
                const key = `${cur.id}>${e.to}`;
                const penalty = edgePenalties.get(key) || 0;
                edgeCost += penalty;
            }
            const nd = cur.d + edgeCost;
            const old = dist.get(e.to);
            if (old === undefined || nd < old) {
                dist.set(e.to, nd);
                prev.set(e.to, { p: cur.id, eFlag: e.eFlag, distKm: e.distKm });
                heap.push({ id: e.to, d: nd });
            }
        }
    }
    if (!dist.has(goal))
        return null;
    const path = [];
    let cur = goal;
    while (cur !== start) {
        path.push(cur);
        const pr = prev.get(cur);
        if (!pr)
            break;
        cur = pr.p;
    }
    path.push(start);
    path.reverse();
    // Patikrinti, ar path turi bent 2 node'us (t.y. bent vieną edge'ą)
    if (path.length < 2)
        return null;
    return { path, prev };
}
// Apskaičiuoti kelio atstumą
export function pathDistanceKm(path, edgeMeta) {
    if (!path || path.length < 2)
        return null;
    let total = 0;
    for (let i = 0; i < path.length - 1; i++) {
        const m = edgeMeta.get(`${path[i]}>${path[i + 1]}`);
        if (!m)
            return null;
        total += m.distKm;
    }
    // Neleistų 0km maršrutų
    return total > 0 ? total : null;
}
// Patikrinti ar maršrutas elektrifikuotas
export function pathElectrified(path, edgeMeta) {
    let hasYes = false;
    let hasNo = false;
    for (let i = 0; i < path.length - 1; i++) {
        const m = edgeMeta.get(`${path[i]}>${path[i + 1]}`);
        if (!m)
            continue;
        if (m.eFlag === "yes")
            hasYes = true;
        if (m.eFlag === "no")
            hasNo = true;
    }
    if (hasYes && hasNo)
        return 'partial';
    if (hasYes)
        return 'yes';
    if (hasNo)
        return 'no';
    return 'unknown';
}
// Rasti K alternatyvių maršrutų
export function findKAlternativePaths(cache, start, goal, K, maxIter = 300) {
    const results = [];
    const seenPaths = new Set();
    const edgePenalties = new Map();
    // 1. Rasti trumpiausią kelią
    const first = dijkstra(cache.adj, start, goal);
    if (!first)
        return [];
    const firstDist = pathDistanceKm(first.path, cache.edgeMeta);
    // Praleisti jei atstumas null arba 0km
    if (firstDist === null || firstDist <= 0)
        return [];
    results.push({ path: first.path, distKm: firstDist });
    seenPaths.add(first.path.join(","));
    // 2. Ieškoti alternatyvų su didėjančiais penalties
    const avgEdgeLength = firstDist / Math.max(1, first.path.length - 1);
    const penaltyStep = avgEdgeLength * 0.3;
    let consecutiveDups = 0;
    for (let iter = 0; iter < maxIter && results.length < K; iter++) {
        // Pridedame penalties tik paskutiniam rastam keliui
        const lastPath = results[results.length - 1].path;
        for (let i = 0; i < lastPath.length - 1; i++) {
            const key1 = `${lastPath[i]}>${lastPath[i + 1]}`;
            const key2 = `${lastPath[i + 1]}>${lastPath[i]}`;
            edgePenalties.set(key1, (edgePenalties.get(key1) || 0) + penaltyStep);
            edgePenalties.set(key2, (edgePenalties.get(key2) || 0) + penaltyStep);
        }
        // Ieškome naujo kelio su penalties
        const newPath = dijkstra(cache.adj, start, goal, edgePenalties);
        if (!newPath)
            break;
        const pathKey = newPath.path.join(",");
        if (seenPaths.has(pathKey)) {
            consecutiveDups++;
            if (consecutiveDups > 10)
                break;
            // Padidiname penalties agresyviau
            for (let i = 0; i < newPath.path.length - 1; i++) {
                const key1 = `${newPath.path[i]}>${newPath.path[i + 1]}`;
                const key2 = `${newPath.path[i + 1]}>${newPath.path[i]}`;
                edgePenalties.set(key1, (edgePenalties.get(key1) || 0) + penaltyStep * 10);
                edgePenalties.set(key2, (edgePenalties.get(key2) || 0) + penaltyStep * 10);
            }
            continue;
        }
        consecutiveDups = 0;
        const dist = pathDistanceKm(newPath.path, cache.edgeMeta);
        // Praleisti maršrutus su null arba 0km atstumu
        if (dist === null || dist <= 0)
            continue;
        results.push({ path: newPath.path, distKm: dist });
        seenPaths.add(pathKey);
    }
    return results;
}
// Sukurti grafą iš OSM duomenų
export function buildGraph(data, gaugeSelected) {
    const nodes = new Map();
    const ways = [];
    for (const el of data.elements) {
        if (el.type === "node" && el.lat !== undefined && el.lon !== undefined) {
            nodes.set(el.id, { lat: el.lat, lon: el.lon, tags: el.tags });
        }
        else if (el.type === "way") {
            ways.push({ nodes: el.nodes || [], tags: el.tags });
        }
    }
    const adj = new Map();
    const edgeMeta = new Map();
    const ensure = (id) => {
        if (!adj.has(id))
            adj.set(id, []);
        return adj.get(id);
    };
    let waysWithoutGaugeCount = 0;
    let waysCount = 0;
    let waysSkippedGauge = 0;
    let waysSkippedRailway = 0;
    for (const w of ways) {
        const tags = w.tags || {};
        if (!isRailwayWay(tags)) {
            waysSkippedRailway++;
            continue;
        }
        if (!isWayUsableForGauge(tags, gaugeSelected)) {
            waysSkippedGauge++;
            continue;
        }
        const ns = w.nodes;
        if (!Array.isArray(ns) || ns.length < 2)
            continue;
        waysCount++;
        if (!tags.gauge)
            waysWithoutGaugeCount++;
        const eFlag = electrifiedFlag(tags);
        for (let i = 0; i < ns.length - 1; i++) {
            const aId = ns[i];
            const bId = ns[i + 1];
            const a = nodes.get(aId);
            const b = nodes.get(bId);
            if (!a || !b)
                continue;
            const d = haversineKm(a.lat, a.lon, b.lat, b.lon);
            edgeMeta.set(`${aId}>${bId}`, { distKm: d, eFlag });
            edgeMeta.set(`${bId}>${aId}`, { distKm: d, eFlag });
            ensure(aId).push({ to: bId, distKm: d, eFlag });
            ensure(bId).push({ to: aId, distKm: d, eFlag });
        }
    }
    // Grid index artimiausiam bėgių mazgui
    const grid = new Map();
    const cellKey = (lat, lon) => `${Math.floor(lat * 100)}_${Math.floor(lon * 100)}`;
    for (const nodeId of adj.keys()) {
        const n = nodes.get(nodeId);
        if (!n)
            continue;
        const k = cellKey(n.lat, n.lon);
        if (!grid.has(k))
            grid.set(k, []);
        grid.get(k).push(nodeId);
    }
    function nearestTrackNode(lat, lon, maxDistKm = 50) {
        const baseX = Math.floor(lat * 100);
        const baseY = Math.floor(lon * 100);
        let best = null;
        let bestD = Infinity;
        for (let dx = -1; dx <= 1; dx++) {
            for (let dy = -1; dy <= 1; dy++) {
                const k = `${baseX + dx}_${baseY + dy}`;
                const ids = grid.get(k);
                if (!ids)
                    continue;
                for (const id of ids) {
                    const n = nodes.get(id);
                    if (!n)
                        continue;
                    const d = haversineKm(lat, lon, n.lat, n.lon);
                    if (d < bestD) {
                        bestD = d;
                        best = id;
                    }
                }
            }
        }
        if (bestD > 5.0) {
            for (let dx = -5; dx <= 5; dx++) {
                for (let dy = -5; dy <= 5; dy++) {
                    const k = `${baseX + dx}_${baseY + dy}`;
                    const ids = grid.get(k);
                    if (!ids)
                        continue;
                    for (const id of ids) {
                        const n = nodes.get(id);
                        if (!n)
                            continue;
                        const d = haversineKm(lat, lon, n.lat, n.lon);
                        if (d < bestD) {
                            bestD = d;
                            best = id;
                        }
                    }
                }
            }
        }
        if (bestD > maxDistKm)
            return null;
        return best !== null ? { id: best, d: bestD } : null;
    }
    // Pridėti rankinės stotelės
    const stationByName = new Map();
    const stationSnapDist = new Map();
    const stationNamesAtNode = new Map();
    const stationPoints = [];
    for (const [normName, info] of Object.entries(manualStations)) {
        if (!info.gauge.includes(gaugeSelected))
            continue;
        const near = nearestTrackNode(info.lat, info.lon, 50);
        if (!near)
            continue;
        stationByName.set(normName, near.id);
        stationSnapDist.set(normName, near.d);
        if (!stationNamesAtNode.has(near.id))
            stationNamesAtNode.set(near.id, new Set());
        stationNamesAtNode.get(near.id).add(info.name);
        stationPoints.push({ name: info.name, norm: normName, lat: info.lat, lon: info.lon, trackNodeId: near.id });
    }
    // Pridėti OSM stotelės
    for (const el of data.elements) {
        if (el.type !== "node" || !el.tags || !el.lat || !el.lon)
            continue;
        const name = getNameFromTags(el.tags);
        if (!name)
            continue;
        const railway = String(el.tags.railway || "");
        const pt = String(el.tags.public_transport || "");
        const train = String(el.tags.train || "");
        const isRailPlatform = railway === "platform" || (pt === "platform" && train === "yes");
        const isRailStopPosition = pt === "stop_position" && (train === "yes" || !!railway);
        const isStation = railway === "station" ||
            railway === "halt" ||
            railway === "stop" ||
            railway === "yard" ||
            railway === "junction" ||
            isRailPlatform ||
            pt === "station" ||
            isRailStopPosition ||
            train === "yes";
        if (!isStation)
            continue;
        let trackNodeId = null;
        let snapD = 0;
        if (adj.has(el.id)) {
            trackNodeId = el.id;
            snapD = 0;
        }
        else {
            const near = nearestTrackNode(el.lat, el.lon);
            if (!near)
                continue;
            trackNodeId = near.id;
            snapD = near.d;
        }
        const nName = normalizeName(name);
        const prevD = stationSnapDist.get(nName);
        if (prevD === undefined || snapD < prevD) {
            stationByName.set(nName, trackNodeId);
            stationSnapDist.set(nName, snapD);
        }
        if (!stationNamesAtNode.has(trackNodeId))
            stationNamesAtNode.set(trackNodeId, new Set());
        stationNamesAtNode.get(trackNodeId).add(name);
        stationPoints.push({ name, norm: nName, lat: el.lat, lon: el.lon, trackNodeId });
    }
    return {
        nodes,
        adj,
        edgeMeta,
        stationByName,
        stationNamesAtNode,
        stationPoints,
        stats: { waysCount, waysSkippedGauge, waysSkippedRailway, waysWithoutGaugeCount }
    };
}
// Apskaičiuoti maršruto ridą ir path
export function calculateRouteMileage(fromStation, toStation, viaStation, gauge, routeData) {
    return __awaiter(this, void 0, void 0, function* () {
        const cache = buildGraph(routeData, gauge);
        const stations1520 = [
            "Akmenė", "Alytus", "Baisogala", "Bezdonys", "Bugeniai", "Darbėnai", "Dotnuva",
            "Dūkštas", "Dūseikiai", "Gaižiūnai", "Gimbogala", "Giruliai",
            "Gubernija", "Gudžiūnai", "Gustonys", "Ignalina", "Jašiūnai", "Jiesia", "Jonaitiškiai",
            "Jonava", "Joniškis", "Kaišiadorys", "Kalnėnai", "Kalvarija", "Kaunas",
            "Kazlų Rūda", "Kėdainiai", "Kena", "Kybartai", "Kirtimai", "Kyviškės", "Kyviškės II,V keliai",
            "Klaipėda", "Kretinga", "Kretingalė", "Kūlupėnai", "Kupiškis", "Kuršėnai", "Kužiai", "Lentvaris",
            "Lieplaukė", "Linkaičiai", "Lukšiai", "Marcinkonys", "Marijampolė", "Matuizos", "Mauručiai",
            "Mažeikiai", "Meškuičiai", "Mockava", "Naujoji Vilnia", "Pabradė", "Pagėgiai",
            "Pakruojis", "Palemonas", "Paneriai", "Panevėžys", "Papilė", "Pavenčiai",
            "Pilviškiai", "Plungė", "Pravieniškės", "Radviliškis", "Raudėnai", "Rimkai",
            "Rokai", "Rokiškis", "Rūdiškės", "Senieji Trakai", "Skuodas", "Stasylos",
            "Stoniškiai", "Šateikiai", "Šeduva", "Šeštokai", "Šiauliai", "Šilainiai",
            "Šilėnai", "Šilutė", "Švenčionėliai", "Tarvainiai", "Tauragė", "Telšiai", "Tytuvėnai",
            "Trakai", "Tryškiai", "Turmantas", "Utena", "Vaidotai", "Valčiūnai", "Valkininkai", "Varėna",
            "Viduklė", "Viekšniai", "Vievis", "Vilkaviškis", "Vilkyčiai", "Vilnius", "Vinčai",
            "VS Bugeniai", "VS Joniškis", "VS Kena", "VS Kybartai", "VS Marcinkonys",
            "VS Mažeikiai", "VS Mockava", "VS Pagėgiai", "VS Rokiškis", "VS Skuodas",
            "VS Stasylos", "VS Turmantas", "Zokniai", "Žasliai", "Žeimiai"
        ];
        const stations1435 = [
            "Jiesia", "Kalvarija", "Kaunas", "Kazlų Rūda", "Marijampolė", "Mauručiai",
            "Mockava", "Palemonas", "Rokai", "Šeštokai", "Vinčai", "VS Mockava"
        ];
        const allowedList = gauge === "1435" ? stations1435 : stations1520;
        const allowedNormToDisplay = new Map();
        for (const d of allowedList) {
            allowedNormToDisplay.set(normalizeName(d), d);
        }
        const fromMatch = findStationNode(cache, fromStation, allowedNormToDisplay);
        const toMatch = findStationNode(cache, toStation, allowedNormToDisplay);
        const viaMatch = viaStation
            ? findStationNode(cache, viaStation, allowedNormToDisplay)
            : { node: null, matchedAs: null };
        const fromNode = fromMatch.node;
        const toNode = toMatch.node;
        const viaNode = viaMatch.node;
        if (!fromNode || !toNode) {
            return { mileage: null, path: null, cache: null };
        }
        let base = null;
        if (viaNode) {
            const a = dijkstra(cache.adj, fromNode, viaNode);
            const b = dijkstra(cache.adj, viaNode, toNode);
            if (a && b) {
                base = { path: a.path.concat(b.path.slice(1)) };
            }
            else {
                base = dijkstra(cache.adj, fromNode, toNode);
            }
        }
        else {
            base = dijkstra(cache.adj, fromNode, toNode);
        }
        if (!base) {
            return { mileage: null, path: null, cache: null };
        }
        const baseDist = pathDistanceKm(base.path, cache.edgeMeta);
        return {
            mileage: baseDist !== null ? Number(baseDist.toFixed(2)) : null,
            path: base.path,
            cache: cache
        };
    });
}
